import * as jsxRuntime from "/builds/lurgan-baptist-church/lbcrm/lbcrm-web/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment